module.exports = __webpack_public_path__ + "static/media/min-receipt.7632dbc2.jpg";